/*
 * - Stores paths for the lookup service endpoints
 */

const serviceRoot = 'api/lookup/';

export const LookupEndpoints = {
  getDistricts: () => `${serviceRoot}getDistricts`,
  getNwpGpPermitTypes: () => `${serviceRoot}getNwpGpPermitTypes`,
  getAllTables: () => `${serviceRoot}getAllLkpTables`,
  getCreditUnitsForDistrict: () => `${serviceRoot}getCreditUnitsForDistrict`,
  getDivisionsAndDistricts: () => `${serviceRoot}divisions-and-districts`,
  getHelpCategories: () => `${serviceRoot}help/categories`,
};
